<template>
  <div class="user">
    <div class="common-form">拼团设置</div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="300px">
        <el-form-item label="拼团失败自动退款">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
          <p>注：如果不开启自动退款，则需要在 [订单管理] 处手动退款</p>
        </el-form-item>
        <el-form-item label="是否允许使用优惠券">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否开启分销">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
          <p>注：如果不开启自动退款，则需要在 [订单管理] 处手动退款</p>
        </el-form-item>

        <div class="common-form">规则描述</div>
        <el-form-item label="规则简述 ">
          <el-input v-model="form.article_title" placeholder="请输入规则简述 "></el-input>
        </el-form-item>
        <el-form-item label="规则详述">
          <el-input type="textarea" v-model="form.desc" placeholder="请输入规则详述 "></el-input>
        </el-form-item>
        <div class="common-form">模板消息</div>
        <el-form-item label="拼团拼单状态通知 ">
          <el-input v-model="form.article_title" placeholder="请填写模板消息ID "></el-input>
          <p>模板编号AT1814，关键词 (订单编号、商品名称、拼团价格、拼团人数、拼团时间、拼团结果) </p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import SharingApi from '@/api/sharing.js';
  export default {
    components: {},
    data() {
      return {
        form: {
          status: 1,
        },
      };
    },
    created() {

    },
    methods: {
      /*选择商品*/
      changeProduct() {
        this.open_add = true;
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        let params = self.form;
        // console.log(params);
        SeckillApi.addActive(params, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/seckill/Product');
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
          })
          .catch(error => {

          });

      },
      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            // console.log(e.params);
            this.form.sharp_product = e.params;
            // this.form.sharp_product = e.params.sharp_product;
            // this.form.product_price = e.params.product_price;
          }
          // console.log(e.params);
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {}
        }
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/plus/sharing/sharing/Setting.vue